import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useVariantsStore } from '../../../store/variants';
export default function Radio({ attribute }) {
    const selectedValues = useVariantsStore((state) => state.selectedValues);
    const updateSelectedValue = useVariantsStore((state) => state.updateSelectedValue);
    return (_jsx("div", { className: "attribute-radio", children: attribute.values.map((value, i) => {
            const selected = selectedValues.some((selectedValue) => selectedValue.attribute.id === attribute.id && selectedValue.value.id === value.id);
            return (_jsxs("div", { children: [_jsx("input", { type: "radio", id: `attribute-radio-${value.id}`, checked: selected, onChange: () => {
                            if (!selected)
                                updateSelectedValue({ attribute, value });
                        } }), _jsx("label", { htmlFor: `attribute-radio-${value.id}`, children: value.value })] }, `radio-attribute-${i}`));
        }) }));
}
